import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Houston needed",
      "Ideal for BTR international travelers",
      "Perfect for LSU students and faculty studying abroad",
      "Great for petrochemical and industrial engineers on international assignments",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Baton Rouge post offices",
      "Good for planned international trips from BTR or MSY",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at East Baton Rouge Parish facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Baton Rouge has no regional passport agency — closest is Houston, ~270 miles away",
      "NPIC appointment required before driving to Houston",
      "Life-or-death emergencies only with documentation",
      "Bereavement or medical crisis documentation required",
      "Expect to spend an entire day traveling and waiting",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function BatonRougeProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Baton Rouge"
      headingExtra="LA"
      introText="Baton Rouge travelers — LSU students and faculty heading abroad, state government employees on international trade missions, petrochemical and industrial engineers on overseas assignments, and Louisiana capital families planning international vacations — have several options for getting a passport fast. Here is how they compare, and why most travelers in Louisiana's capital choose a U.S. Department of State registered passport courier for predictable, professional processing without the 4+ hour drive to Houston."
      options={options}
      emergencyDescription="Baton Rouge does not have its own regional passport agency. The closest agency is the Houston Passport Agency — approximately 270 miles west via I-10, a 4+ hour drive each way. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted. For most Baton Rouge residents, this is not a realistic option."
      disclaimerText="*Processing speed depends on eligibility and documentation. Baton Rouge does not have a regional passport agency — the closest is Houston, roughly 270 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}